import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';


const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
  };

class SectionSell extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {
        return (
            <div className="row flex">
                <div className="col-md-6">
                {intl.get('cal.step01')}
                    
                </div>
                <div className="col-md-6 right">
                    <a href="https://go.track.co/fale-com" className="btn_faca">{intl.get('cal.step02')}</a>
                </div>
            </div>

        );

    }
}

export default SectionSell;
